module.exports = __webpack_public_path__ + "static/img/about_brainstorm.0d08e96.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about_brainstorm.svg
// module id = 155
// module chunks = 2